import { render, staticRenderFns } from "./_jpo.vue?vue&type=template&id=e88b52cc"
import script from "./_jpo.vue?vue&type=script&lang=js"
export * from "./_jpo.vue?vue&type=script&lang=js"
import style0 from "./_jpo.vue?vue&type=style&index=0&id=e88b52cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderDiploma: require('/home/etienne/AM-frontend/components/HeaderDiploma.vue').default,ErrorFieldHandler: require('/home/etienne/AM-frontend/components/ErrorFieldHandler.vue').default,FormErrorPopUp: require('/home/etienne/AM-frontend/components/FormErrorPopUp.vue').default})
